import { render, staticRenderFns } from "./AccountHolderDependents.vue?vue&type=template&id=250cc904&scoped=true"
import script from "./AccountHolderDependents.vue?vue&type=script&lang=ts"
export * from "./AccountHolderDependents.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderDependents.vue?vue&type=style&index=0&id=250cc904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250cc904",
  null
  
)

export default component.exports